"use strict";

require("core-js/modules/es.object.from-entries.js");

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformNestedObjectValues = void 0;

function transformNestedObjectValues(object, transformer) {
  var entries = Object.entries(object).map(function (_a) {
    var _b = __read(_a, 2),
        key = _b[0],
        value = _b[1];

    if (typeof value === 'object') {
      return [key, transformNestedObjectValues(value, transformer)];
    } else {
      return [key, transformer([key, value])];
    }
  });
  return Object.fromEntries(entries);
}

exports.transformNestedObjectValues = transformNestedObjectValues;